export default __webpack_public_path__ + "c0bd568e8b68960f63c1dab669d1127f.svg";